module.exports = __webpack_public_path__ + "img/ps.8f640b1a.svg";